import React, { useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import CleaningSummaryCards from "../../Components/cleaning/CleaningSummaryCards";
import CleaningCameraHeatmap from "../../Components/cleaning/CleaningCameraHeatmap";
import CleaningCoverageBars from "../../Components/cleaning/CleaningCoverageBars";
import FilterBar from "../../Components/studentDistribution/FilterBar";
// import { useQuery } from "@tanstack/react-query";
import EmptyState from "../../Components/studentDistribution/EmptyState";

// --- API (commented for now, using dummy data) ---
// const CLEANING_API_BASE =
//   process.env.REACT_APP_CLEANING_API_URL ||
//   process.env.REACT_APP_API_BASE_URL ||
//   process.env.REACT_APP_API_URL ||
//   "http://localhost:4200";

export const Hyzine: React.FC = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  // --- API: Check if there's data for the selected date (commented for now) ---
  // const { data: metricsRes, isFetching, isSuccess } = useQuery({
  //   queryKey: ["cleaningDataCheck", date],
  //   queryFn: () => fetch(`${CLEANING_API_BASE}/cleaning/latest-coverage?date=${date}`).then((r) => r.json()),
  //   refetchOnWindowFocus: false,
  // });
  // const metricsData = (metricsRes as any)?.data ?? metricsRes;
  // const hasData = isSuccess && Array.isArray(metricsData) && metricsData.length > 0 && metricsData.some((m: any) => m.value !== "-" && m.value !== "N/A");
  // const showEmptyState = isSuccess && !isFetching && !hasData;

  // Using dummy data - always show dashboard (no empty state for now)
  const showEmptyState = false;

  return (
    <div className={`min-h-screen w-full p-6 ${isDarkMode ? "bg-[#0b0d14]" : "bg-gray-50"}`}>
      <div
        className={`mb-8 p-6 rounded-2xl ${isDarkMode ? "bg-[#161b2b] border border-gray-800" : "bg-white border border-gray-100 shadow-sm"}`}
      >
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h1 className={`text-2xl font-bold transition-all duration-300 ${isDarkMode ? "text-white" : "text-gray-900"}`}>
              Cleaning & Hygiene
            </h1>
            <p className={`text-sm transition-all duration-300 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>
              Monitor cleaning coverage and hygiene standards across cameras
            </p>
          </div>

          <FilterBar
            filters={[
              {
                label: "Date",
                value: date,
                onChange: setDate,
                type: "date",
              },
            ]}
            className="!mb-0 shadow-sm"
          />
        </div>
      </div>

      {showEmptyState ? (
        <div
          className={`mt-12 rounded-2xl border p-12 flex flex-col items-center justify-center transition-all duration-300 ${
            isDarkMode ? "bg-[#1C202F] border-gray-800" : "bg-white border-gray-100 shadow-sm"
          }`}
        >
          <EmptyState
            variant="camera"
            title="No presence data yet"
            description={
              date
                ? `No cleaning or hygiene data was found for ${new Date(date).toLocaleDateString()}.`
                : "No presence data found for the selected date."
            }
            isDarkMode={isDarkMode}
          />
        </div>
      ) : (
        <>
          <CleaningSummaryCards date={date} />
          <CleaningCameraHeatmap date={date} />
          <CleaningCoverageBars date={date} />
        </>
      )}
    </div>
  );
};

export default Hyzine;
